import { createApi } from "@reduxjs/toolkit/query/react";
import { gql } from "graphql-request";
import customBaseQuery from "../../../utils/customBaseQuery";

export const ManageRoleDashboardAPI = createApi({
  reducerPath: "ManageRoleDashboardAPI",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    searchUsersByRoles: builder.query({
      query: (args: {
        roleIds: string[];
        userIds: string[];
        searchKey: string;
        userRoleStatus: string[];
        pageNumber: number;
        pageSize: number;
        sortKey: string;
        sortOrder: string;
      }) => ({
        url: "/graphql",
        body: gql`
          query SearchUsersByRoles {
            searchUsersByRoles(
              request: {
                roleIds: [${args.roleIds.map((id) => `"${id}"`).join(", ")}]
                userIds: [${args.userIds.map((id) => `"${id}"`).join(", ")}]
                searchKey: "${args.searchKey}"
                userRoleStatus: [${args.userRoleStatus.map((s) => `"${s}"`).join(", ")}]
              }
              sortCriteria: {
                pageSize: ${args.pageSize}
                pageNo: ${args.pageNumber}
                order: "${args.sortOrder}"
                sortKey: "${args.sortKey}"
              }
            ) {
              timeStamp
              version
              error
              data {
                pageNumber
                pageSize
                totalCount
                users {
                  userId
                  name {
                    fullName
                  }
                  email
                  profileImageUrl
                  employment {
                    bg
                    du
                    band
                    role
                    grade
                    title
                    clientName
                    designation
                    organization
                    operatingUnit
                    assignmentStatus
                  }
                  roles {
                    userId
                    roleId
                    role
                    alias
                    expiry
                    active
                    createdat
                    createdby
                    updatedat
                    updatedby
                  }
                    project{
                      projectName
                  }
                  name {
                    fullName
                  }
                }
              }
            }
          }
        `
        // params: {
        //   variables: {
        //     roleIds: [],
        //     userIds: [],
        //     searchKey: "",
        //     userRoleStatus: [],
        //   },
        // },
      }),
      extraOptions: { service: "Utility" }
    })
  })
});

export const { useSearchUsersByRolesQuery, useLazySearchUsersByRolesQuery } =
  ManageRoleDashboardAPI;
